import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 16"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M4 5h4c1.7 0 2-1.3 2-3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2 0 1.7.3 3 2 3m0-3V1c0-.6.5-1 1-1h2c.5 0 1 .4 1 1v1.3c0 .6-.4.7-1 .7H5a1 1 0 0 1-1-1"
    }, null, -1)
  ]));
}
const interfaceCopyClipboard = { render };
export {
  interfaceCopyClipboard as default,
  render
};
//# sourceMappingURL=interface-copy-clipboard.svg.js.map
